import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import WhiteBlockTitle from './../block/WhiteBlockTitle'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'
import GreenButton from './../block/GreenButton'
import UslugiLastCard from './../block/UslugiLastCard'
import FeedbackForm from './../block/FeedbackForm'
import ClientOnlyFsLightbox from './../block/ClientOnlyFsLightbox'

import styles from './../style/Uslugi.module.scss'

import { Container, Image } from 'react-bootstrap'

class Uslugi extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      active: 0,
      show_feedback: false,
      feedback_title: ``,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = ( title ) => {
    this.setState({ show_feedback: true, feedback_title: title });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  // Функция для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, protocol, assets_path } = this.props,
    { show_feedback, feedback_title, lightboxController } = this.state

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <div className={styles.uslugi}>
          <Container>
            {/* Lightbox компонент */}
            <ClientOnlyFsLightbox
              toggler={lightboxController.toggler}
              sources={data?.uslugicards.map(item => item.full || item.image)}
              slide={lightboxController.slide}
            />

            <WhiteBlockTitle
              title={data?.pagetitle}
              text={``}
            />
            <div className={styles.cards}>
              {data?.uslugicards.map(( elm, k ) => (
                <div className={styles.cards_elm} key={k}>
                  {elm?.image != `` &&
                    <Image 
                      className={styles.cards_elm_image} 
                      src={elm?.image} 
                      width={256} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                  <div>
                    <div className={styles.cards_elm_top}>
                      <div className={styles.cards_elm_top_name}>{elm?.name}</div>
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.cards_elm_text}>{elm?.text}</div>
                    {elm?.text2 != `` &&
                      <div className={styles.cards_elm_card}>
                        {elm?.name2 != `` ?
                          <div>
                            <div className={styles.cards_elm_top}>
                              <div className={styles.cards_elm_iconblock}>
                                <Image src={elm?.icon} alt={`icon-${k}`} width={18} height={18} />
                                <div className={styles.cards_elm_top_name}>{elm?.name2}</div>
                              </div>
                              <GreenButton
                                text={elm?.bnt != `` ? elm?.bnt : `Заказать бесплатный замер`}
                                width={233}
                                svg={(
                                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.8737 11.9173H8.1237C10.832 11.9173 11.9154 10.834 11.9154 8.12565V4.87565C11.9154 2.16732 10.832 1.08398 8.1237 1.08398H4.8737C2.16536 1.08398 1.08203 2.16732 1.08203 4.87565V8.12565C1.08203 10.834 2.16536 11.9173 4.8737 11.9173Z" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.75 3.25L3.25 9.75" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.7487 5.41667V3.25H7.58203" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M3.25 7.58398V9.75065H5.41667" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                )}
                                className={styles.button}
                                action={() => this.showFeedback( elm?.bnt != `` ? elm?.bnt : `Заказать бесплатный замер` )}
                              />
                            </div>
                            <div className={styles.cards_elm_text}>{elm?.text2}</div>
                          </div>
                        :
                          <>
                            <div className={styles.cards_elm_contentblock}>
                              <Image src={elm?.icon} alt={`icon-${k}`} width={18} height={18} />
                              <div className={styles.cards_elm_text}>{elm?.text2}</div>
                              <GreenButton
                                text={elm?.bnt != `` ? elm?.bnt : `Заказать бесплатный замер`}
                                width={233}
                                svg={(
                                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.8737 11.9173H8.1237C10.832 11.9173 11.9154 10.834 11.9154 8.12565V4.87565C11.9154 2.16732 10.832 1.08398 8.1237 1.08398H4.8737C2.16536 1.08398 1.08203 2.16732 1.08203 4.87565V8.12565C1.08203 10.834 2.16536 11.9173 4.8737 11.9173Z" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.75 3.25L3.25 9.75" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.7487 5.41667V3.25H7.58203" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M3.25 7.58398V9.75065H5.41667" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                )}
                                className={styles.button}
                                action={() => this.showFeedback( elm?.bnt != `` ? elm?.bnt : `Заказать бесплатный замер` )}
                              />
                            </div>
                          </>
                        }
                      </div>
                    }
                  </div>
                </div>
              ))}
              <UslugiLastCard
                assets_path={assets_path}
              />
            </div>
          </Container>
        </div>
        <FeedbackForm
          title={feedback_title}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Uslugi.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Uslugi.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Uslugi